import React from 'react';
import { Button } from './ui/button';
import { TrendingUp, Shield, Zap } from 'lucide-react';

const FeaturesSection = () => {
  const features = [
    {
      icon: TrendingUp,
      title: 'CRYPTO Tailor-made',
      subtitle: 'Accompagnement sur mesure',
      description: "Un analyste financier senior vous est personnellement dédié afin de définir une stratégie d'investissement sur mesure, adaptée à vos objectifs et à votre profil. Il en assure également le suivi régulier pour optimiser la performance de votre portefeuille dans la durée.",
      cta: '',
      gradient: 'from-blue-500/20 to-purple-500/20'
    },
    {
      icon: Shield,
      title: 'Crypto.com Advanced',
      subtitle: 'Produits d\'épargne personnalisés',
      description: 'Découvrez des solutions d\'investissement sur mesure, pensées pour correspondre à votre profil d\'investisseur et à vos ambitions financières. Que vous souhaitiez sécuriser votre capital, diversifier vos placements ou dynamiser vos rendements, nous construisons une stratégie claire et efficace, en accord avec vos priorités.',
      cta: '',
      gradient: 'from-purple-500/20 to-pink-500/20'
    },
    {
      icon: Zap,
      title: 'CRYPTO Exclusive member',
      subtitle: 'Avantages exclusifs membres',
      description: 'Ici, pas de frais cachés ni de commissions fixes : nous ne sommes rémunérés que sur vos résultats. Notre objectif est le même que le vôtre — faire croître votre capital. C\'est une véritable relation de confiance et de performance partagée, où chaque décision vise un seul but : vous faire gagner.',
      cta: '',
      gradient: 'from-cyan-500/20 to-blue-500/20'
    }
  ];

  return (
    <section className="py-10 sm:py-16 lg:py-20 bg-[#0B1426]">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="space-y-10 sm:space-y-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Content */}
              <div className={`space-y-4 sm:space-y-6 ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="inline-block">
                  <feature.icon className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-blue-400" />
                </div>
                <div>
                  <p className="text-blue-400 font-semibold mb-1 sm:mb-2 tracking-wide uppercase text-xs sm:text-sm">
                    {feature.title}
                  </p>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2 sm:mb-4">{feature.subtitle}</h2>
                  <p className="text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed">{feature.description}</p>
                </div>
                {feature.cta && (
                  <Button className="bg-blue-500 hover:bg-blue-600 text-white text-sm sm:text-base">
                    {feature.cta}
                  </Button>
                )}
              </div>

              {/* Visual */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div
                  className={`relative bg-gradient-to-br ${feature.gradient} rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 border border-blue-500/30 shadow-2xl h-48 sm:h-64 lg:h-96 flex items-center justify-center overflow-hidden`}
                >
                  {/* Decorative elements */}
                  <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
                  <div className="relative z-10">
                    <feature.icon className="w-16 h-16 sm:w-24 sm:h-24 lg:w-32 lg:h-32 text-white/20" />
                  </div>
                  {/* Animated glow */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 sm:w-48 lg:w-64 h-32 sm:h-48 lg:h-64 bg-blue-500/30 rounded-full blur-3xl animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
